var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddFont(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138,
    height: 42,
    viewBox: "0 0 138 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29293",
    "data-name": "Group 29293",
    transform: "translate(16 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29295",
    "data-name": "Group 29295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29307",
    "data-name": "Group 29307"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 138,
    height: 42,
    rx: 21,
    transform: "translate(-16 -9)",
    fill: "#4a8409"
  }), /*#__PURE__*/React.createElement("text", {
    id: "CREATE_REQUEST",
    "data-name": "CREATE REQUEST",
    transform: "translate(53 19)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44,
    y: 0
  }, "ADD FONT")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFont);
export default __webpack_public_path__ + "static/media/addFont.5a7ba7dd.svg";
export { ForwardRef as ReactComponent };